import React from "react"
import {
	ColorKeys,
	Text,
	Flex,
	Image,
	Button,
} from "@capioweb/ui-components/src"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { assetBaseUrl, imageUrlToImageProps, sendCtaClickLayerPush, urlIsInternal } from "../../utils"
import { BlockCommonLayout } from "../../utils/layout"
import { CapioInformation } from ".."

export type InformationItemsProps = {
	header: string
	imageAlternateText?: string
	imageTitle?: string
	imageUrl?: string
	informationText?: string
	linkTarget?: string
	linkText?: string
	linkTitle?: string
	linkUrl?: string
}

interface CapioInformationContainerBlockProps {
	heading: StringProperty
	backgroundColor: ColorKeys
	informationItems?: [InformationItemsProps]
	anchorId?: StringProperty
}

const CapioInformationContainerBlock: React.FC<CapioInformationContainerBlockProps> =
	(props) => {
		const hasMultipleItems = props.informationItems.length > 1
		const srcSetSizes = [{ width: 800, breakpoint: 2560 }]

		return (
			props.informationItems.length > 0 && (
				<BlockCommonLayout
					id={props.anchorId?.value ?? null}
					heading={props.heading}
					backgroundColor={props.backgroundColor}
				>
					{props.informationItems?.map((item, i, array) => {
						const hasImageOrInfoText =
							item.informationText !== null || item.imageUrl !== null
						const isNotFirstItem = i > 0

						return (
							<Flex w={1} key={i} flexDirection="column">
								{isNotFirstItem && (
									<Flex w={1} minh="1px" backgroundColor="navy"></Flex>
								)}
								<Flex
									key={i}
									pb={
										props.backgroundColor === "white" && i === array.length - 1
											? 0
											: 5
									}
									pt={{ _: isNotFirstItem ? 5 : 0, m: isNotFirstItem ? 5 : 0 }}
									w={1}
									flexDirection={{ _: "column", m: "row" }}
									columnGap={3}
								>
									{item.imageUrl && (
										<Flex w={1} h="fit-content" pb={{ _: 4, m: 0 }}>
											<Image
												{...imageUrlToImageProps(
													`${assetBaseUrl()}${item.imageUrl}?format=webp"}`,
													item.imageTitle,
													item.imageAlternateText,
													true,
													true,
													srcSetSizes
												)}
												cover
												ratio={9 / 16}
											></Image>
										</Flex>
									)}
									<Flex
										w={1}
										alignSelf="flex-start"
										maxw={69}
										mx={hasMultipleItems || item.imageUrl ? "none" : "auto"}
									>
										<Flex
											alignItems={
												hasMultipleItems || hasImageOrInfoText
													? "flex-start"
													: "center"
											}
											py={0}
											w={1}
											flexDirection="column"
										>
											<Text
												variant="headline-3"
												textAlign={
													hasMultipleItems
														? "left"
														: hasImageOrInfoText
															? "left"
															: "center"
												}
											>
												{item.header}
											</Text>
											{item.informationText && (
												<CapioInformation
													informationText={item.informationText}
												/>
											)}

											{item.linkUrl && (
												<Flex
													flexDirection="column"
													w={{ _: 1, m: "auto" }}
													mt="auto"
													maxw={50}
												>
													{!urlIsInternal(item.linkUrl) ? (
														<Button.Anchor
															href={item.linkUrl}
															target={item.linkTarget}
															title={item.linkTitle}
															variant="ghost"
															onClick={() => sendCtaClickLayerPush(item.linkText)}
														>
															{item.linkText}
														</Button.Anchor>
													) : (
														<Button.Link
															to={item?.linkUrl ?? "#"}
															title={item.linkTitle}
															variant="ghost"
															onClick={() => sendCtaClickLayerPush(item.linkText)}
														>
															{item.linkText}
														</Button.Link>
													)}
												</Flex>
											)}
										</Flex>
									</Flex>
								</Flex>
							</Flex>
						)
					})}
				</BlockCommonLayout>
			)
		)
	}

export { CapioInformationContainerBlock }
